import styled from "styled-components";
import Body from "features/shared/styles/typography/Body.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";

const CardContent = styled.div`
  ${Body} {
    margin-top: 8px;
  }
  ${Summary} {
    margin-top: 16px;
  }
`;

export default CardContent;
